<template>
  <div class="wrsp">
    <section class="living-list" v-if="dataList.length">
      <p class="title">
        <span>{{ $t("livingPage.pageTitle") }}</span>
      </p>
      <div
        class="list"
        v-for="(li, index) in dataList"
        :key="index"
        @click="goLivingRoom(li)"
      >
        <div class="liv-state">
          <div class="cover-img">
            <img
              :src="li.img ? li.img : defaultCover"
              @error="changCover(li)"
            />
            <img
              src="@/assets/img/new/video.png"
              class="apply-btn"
              v-if="li.live_status == 1"
            />
            <div v-else-if="li.live_status == 2" class="count-down">
              <span>{{ Math.floor(li.left_start_sec / 86400) }}</span>
              {{ $i18n.locale == "zh" ? "天" : "Days" }}
              <span>{{ Math.floor(li.left_start_sec / 3600) % 24 }}</span>
              {{ $i18n.locale == "zh" ? "时" : "Hrs" }}
              <span>{{ Math.floor(li.left_start_sec / 60) % 60 }}</span>
              {{ $i18n.locale == "zh" ? "时" : "Min." }}
            </div>
            <div v-else-if="li.live_status == 3" class="count-down">
              <img src="@/assets/img/new/nav-re.png" class="apply-btn" />
            </div>
            <p v-else class="count-down">
              <span>{{ $t("livingPage.coverOverHint") }}</span>
            </p>
          </div>
          <p class="state state1" v-if="li.live_status == 1">
            {{ $t("livingPage.onLive") }}
          </p>
          <p class="state state2" v-else-if="li.live_status == 2">
            {{ $t("livingPage.notStart") }}
          </p>
          <p class="state state3" v-else-if="li.live_status == 3">
            {{ $t("livingPage.duringPlayback") }}
          </p>
          <p class="state state4" v-else>{{ $t("livingPage.isOver") }}</p>
        </div>
        <div class="living-info">
          <p class="name over-hide">{{ li.name }}</p>
          <p class="teacher">
            {{ $t("livingPage.lecturer") }}：{{ li.teacher_name }}
          </p>
          <p
            :class="li.is_favorite == 1 ? 'like-liv-active' : 'like-liv'"
            @click.stop="collectLiv(li)"
          >
            {{ li.favorite_num }}{{ $i18n.locale == "zh" ? "人" : "" }}
          </p>
          <p v-if="li.live_status == 1" class="start-time">
            <span>{{ $t("livingPage.broadcastTime") }}</span
            >：{{ li.study_total_time }}
          </p>
          <p v-else-if="li.live_status == 2" class="start-time">
            {{ $t("livingPage.theAirtime") }}：{{ li.valid_start_time }}
          </p>
          <p v-else-if="li.live_status == 3" class="start-time">
            {{ $t("livingPage.playbackTime") }}：{{ li.replay_start }}-{{
              li.replay_end
            }}
          </p>
          <p v-else-if="li.live_status == 4" class="start-time">
            {{ $t("livingPage.endTime") }}：{{ li.valid_end_time }}
          </p>
        </div>
      </div>
      <p
        class="look-more"
        v-if="dataList.length == 2"
        @click="$router.push({ name: 'livingList' })"
      >
        {{ $t("columnVideo.seeMore") }}
      </p>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [],
      defaultCover: require("@/assets/img/new/basic_train.png"),
    };
  },
  created() {
    this.getLivingList();
  },
  methods: {
    getLivingList() {
      this.$axios.post(`index.php/mobile/live/list`, {}).then((res) => {
        this.dataList = res.data.result.data.slice(0, 2);
      });
    },
    // 图片加载失败
    changCover(item) {
      item.img = this.defaultCover;
    },
    // 收藏直播
    collectLiv(item) {
      this.$axios
        .post(`index.php/mobile/favorite/item`, {
          item: item.resources_id,
          trainplan_id: item.trainplan_id,
          type: 11,
        })
        .then((res) => {
          if (res.data.code === 0) {
            item.is_favorite = res.data.result.is_favorite;
            item.favorite_num = res.data.result.is_favorite
              ? parseInt(item.favorite_num) + 1
              : parseInt(item.favorite_num) - 1;
          }
        })
        .catch(() => {});
    },
    // 跳转到直播详情
    goLivingRoom(item) {
      this.$router.push({
        path: "livingDetail",
        query: { r_id: item.resources_id, t_id: item.trainplan_id },
      });
    },
  },
};
</script>
<style scoped lang="less">
@import "~@/assets/sass/color.less";
.living-list {
  .title {
    color: #666666;
    height: 0.72rem;
    line-height: 0.72rem;
    font-size: 0.28rem;
    text-align: center;
    background: #fff;
    border-bottom: solid 0.01rem #eee;
    span {
      position: relative;
      &:before {
        .modified-line;
        left: -0.3rem;
      }
      &:after {
        .modified-line;
        right: -0.3rem;
      }
    }
  }
  .list {
    display: flex;
    padding: 0.2rem 0.3rem;
    background: white;
    margin-bottom: 0.2rem;
    .liv-state {
      width: 2.8rem;
      .state {
        color: white;
        font-size: 0.2rem;
        padding-left: 0.55rem;
        margin-top: 0.15rem;
        height: 0.35rem;
        display: flex;
        align-items: center;
        // padding-top: .05rem;
        border-radius: 0.2rem;
        display: inline-block;
        padding-right: 0.1rem;
      }
      .state1 {
        background: url("~@/assets/img/new/vdicon.png") no-repeat 0.13rem center
          @passColor;
        background-size: 0.3rem;
      }
      .state2 {
        background: url("~@/assets/img/new/vkb.png") no-repeat 0.13rem center
          @mColor;
        background-size: 0.3rem;
      }
      .state3 {
        background: url("~@/assets/img/new/re.png") no-repeat 0.13rem center
          #a46c59;
        background-size: 0.3rem;
      }
      .state4 {
        background: url("~@/assets/img/new/js.png") no-repeat 0.13rem center
          #aaa;
        background-size: 0.3rem;
      }
    }
    .cover-img {
      height: 1.5rem;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        .absolutely-centered;
        z-index: 4;
      }
      .apply-btn {
        width: 0.7rem;
        .absolutely-centered;
      }
      .count-down {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        color: rgba(255, 255, 255, 0.7);
        position: relative;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.25rem;
        span {
          font-size: 0.34rem;
        }
      }
    }
    .living-info {
      flex: 1;
      overflow: hidden;
      margin-left: 0.2rem;
      .name {
        font-size: 0.29rem;
        font-weight: 600;
      }
      .teacher {
        font-size: 0.24rem;
        font-weight: 600;
      }
      .like-liv-active {
        background: url("~@/assets/img/new/faved.png") no-repeat left top;
        padding-top: 0.36rem;
        margin-top: 0.1rem;
        padding-left: 0.05rem;
        background-size: 0.36rem;
        width: 1rem;
      }
      .like-liv {
        .like-liv-active;
        background: url("~@/assets/img/new/fav.png") no-repeat left top;
        background-size: 0.36rem;
      }
      .start-time {
        margin-top: 0.1rem;
        font-size: 0.24rem;
        span {
          color: @mColor;
        }
      }
    }
  }
}
.modified-line {
  content: "";
  position: absolute;
  top: 50%;
  width: 0.22rem;
  height: 0.02rem;
  background: #666;
}
.look-more {
  text-align: center;
  line-height: 0.7rem;
  background: white;
  color: @mColor;
  margin-top: -0.18rem;
  font-size: 0.22rem;
}
</style>
